import { render, staticRenderFns } from "./order-list2.vue?vue&type=template&id=461dbc7b&scoped=true"
import script from "./order-list2.vue?vue&type=script&lang=js"
export * from "./order-list2.vue?vue&type=script&lang=js"
import style0 from "./order-list2.vue?vue&type=style&index=0&id=461dbc7b&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/shop/order-list.less?vue&type=style&index=1&id=461dbc7b&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461dbc7b",
  null
  
)

export default component.exports